import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Transforms } from 'slate';
import { useSlateStatic, useSelected } from 'slate-react';
import classNames from 'classnames';
import DeleteIcon from '@material-ui/icons/Delete';
import { ReactComponent as AudioIconWhite } from "../../../../images/audio-white.svg";
import { ReactComponent as AudioIconGreen } from "../../../../images/audio-green.svg";
import {
  Button,
  ButtonGroup,
  CircularProgress,
} from '@material-ui/core';

import '../../../device-preview/modules/_audio.scss';
import DevicePreviewContext from '../../../../contexts/DevicePreviewContext';

const AudioPlayer = ({ attributes, element, children, previewMode }) => {
  const editor = useSlateStatic();
  const [audioFile, setAudioFile] = useState(null);
  const [playing, setPlaying] = useState(false);
  const [audioFileLoaded, setAudioFileLoaded] = useState(false)
  const selected = useSelected();

  const { previewOpen } = useContext(DevicePreviewContext)

  const stopAudio = useCallback(() => {
    setPlaying(false)
    audioFile.pause()
    audioFile.currentTime = 0;
  }, [audioFile])

  const playAudio = () => {
    setPlaying(true)
    audioFile.play()
  }

  useEffect(() => {
    if (element.src != null) {
      const audioFile = new Audio(element.src)

      audioFile.addEventListener("ended", () => setPlaying(false))
      audioFile.addEventListener("canplaythrough", () => setAudioFileLoaded(true))

      setAudioFile(audioFile)
    }
  }, [element.src])

  useEffect(() => {
    if (!previewOpen && audioFile !== null) {
      stopAudio()
    }
  }, [previewOpen, audioFile, stopAudio])

  const deleteAudio = () => {
    Transforms.removeNodes(editor, { match: (n) => n.id === element.id });
  };

  const handleAudioClicked = () => {
    if (audioFile) {
      if (playing) {
        stopAudio()
      } else {
        playAudio()
      }
    }
  }

  const getAudioPlayerIcon = () => playing ? <AudioIconGreen /> : <AudioIconWhite />

  if (previewMode) {
    return (
      <div
        className={`audio-content`}
        contentEditable={false}
        {...attributes}
      >
        <div className={'audio-wrapper preview'} onClick={handleAudioClicked}>
          {getAudioPlayerIcon()}  Listen here
        </div>
      </div>
    );
  }

  return (
    <div
      className="audio-content"
      contentEditable={false}
      tabIndex="0"
      {...attributes}
    >
      <div
        className={classNames({
          'audio-container': true,
          'is-selected': selected,
        })}
        tabIndex="-1"
      >
        {!element.isUploading && element.src != null && audioFileLoaded ? (
          <div className={'audio-wrapper'}>
            <AudioIconWhite /> Listen here
          </div>
        ) : (
          <div className={'audio-upload-loader-wrapper'}>
            <CircularProgress className="loader" />
          </div>
        )}
        <div className="edit-bar">
          <ButtonGroup
            orientation="vertical"
            color="primary"
            aria-label="vertical contained primary button group"
            variant="contained"
          >
            <Button onMouseDown={deleteAudio}>
              <DeleteIcon />
            </Button>
          </ButtonGroup>
        </div>
      </div>
      {children}
    </div>
  );
};

export default AudioPlayer;
